import { render } from "./ProcessBoard.vue?vue&type=template&id=53f64fdf&scoped=true"
import script from "./ProcessBoard.vue?vue&type=script&lang=js"
export * from "./ProcessBoard.vue?vue&type=script&lang=js"

import "./ProcessBoard.vue?vue&type=style&index=0&id=53f64fdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f64fdf"]])

export default __exports__